<template>
<div class="chapter">
<div class="inner_page">
<p class="default" id="d8e53NaN">
</p><p class="serh"><img alt="9781937084646_txt_0001_001" class="imgpub" id="d14e43" src="images/9781937084646_txt_0001_001.jpg"/></p>
<p class="h2" id="d7e111"><b>WRITTEN AND WITH PHOTOGRAPHS </b><br/><b>BY GRETTA PARKER </b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Park_9781937084721_epub_c1_r1.vue?ae9d994c